const SHORT_MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/**
 * Footer copyright year and short month label (e.g. "Aug 2026").
 * @param {Date} [date]
 */
export function getFooterMeta(date = new Date()) {
  return {
    year: date.getFullYear(),
    monthYear: `${SHORT_MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`,
  };
}

/**
 * Short month label for mock/demo UI (e.g. landing previews).
 * @param {Date} [date]
 */
export function getShortMonthYearLabel(date = new Date()) {
  return `${SHORT_MONTH_NAMES[date.getMonth()]} ${date.getFullYear()}`;
}
